/**
 * How a job Sun resolved is named on the widget's screens (amendment 6, common rule (a) of RN26-RN31).
 *
 * Sun sends the code as the name when the node of the flow has none, so painting both would read
 * "OP10 · OP10". The name is shown only when it says something the code does not: not empty, and not
 * the code itself once trimmed and compared without case.
 */

const sameText = (one, other) => one.trim().toLowerCase() === other.trim().toLowerCase()

/** The job's name when it differs from its code; '' otherwise. */
export const jobName = (job = {}) => {
  const name = job.name ?? ''
  const code = job.code ?? ''
  return name.trim() === '' || sameText(name, code) ? '' : name
}

/** "OP10 · Milling Roughing", or "OP10" when the name adds nothing. The separator is not translated. */
export const jobLabel = (job = {}) => {
  const name = jobName(job)
  return name === '' ? job.code ?? '' : (job.code ?? '') + ' · ' + name
}
